import React from "react";
import clsx from "clsx";
import { Box } from "@curves/ui-base";
import { isFunction } from "@util/utils";
import { isValidDate } from "@util/moment";

const TransactionListTriggerButton = (props) => {
	const { children, sourceData, refresh, dialogRef } = props;
	const isShow = isValidDate(sourceData?.statisticsDate);

	const handleClick = () => {
		if (isShow) {
			const { openTransactionListDialog } = dialogRef.current || {};
			isFunction(openTransactionListDialog) && openTransactionListDialog(sourceData, refresh);
		}
	};

	return (
		<Box className={clsx("table-cell-controller", { "no-control": !isShow })} onClick={handleClick}>
			{children}
		</Box>
	);
};

export default TransactionListTriggerButton;
